module.exports = __webpack_public_path__ + "media/images/gradient-blue-background-4-e23fd2253b8fa310271087cf7ee541ed.jpg";